"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Plane = function Plane(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Destination-page---Desktop",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.506,8.25,5.24,8.272l-1.1-2.2-2.293-.1A1.1,1.1,0,0,0,.84,7.5l2.067,4.668A2.2,2.2,0,0,0,4.924,13.5H8.965L6.481,18.668a1.086,1.086,0,0,0,.967,1.582h2.1a1.1,1.1,0,0,0,.843-.395L15.55,13.5h4.956a2.616,2.616,0,0,0,2.744-2.589A2.674,2.674,0,0,0,20.506,8.25Z",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.72,8.209l-2.992-4.02a1.1,1.1,0,0,0-.878-.439H9.782A1.1,1.1,0,0,0,8.8,5.339L10.239,8.25",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }))));
};
Plane.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Plane.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Plane;